/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contracts_Create_TitleInputs */

const cs_contracts_create_title = /** @type {(inputs: Contracts_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová smlouva`)
};

const en_contracts_create_title = /** @type {(inputs: Contracts_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New contract`)
};

/**
* | output |
* | --- |
* | "New contract" |
*
* @param {Contracts_Create_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contracts_create_title = /** @type {((inputs?: Contracts_Create_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contracts_Create_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contracts_create_title(inputs)
	return cs_contracts_create_title(inputs)
});